import { memo } from 'react';
import { FiChevronRight } from 'react-icons/fi';
import LanguageMenu from './LanguageMenu';
import { isLanguageCategory } from '../../utils/languageNavigation';

// Sidebar Item Component - matches profile sidebar style
const SidebarItem = ({ label, isActive, onClick, hasChevron = true }) => (
  <button
    onClick={onClick}
    className={`w-full flex items-center justify-between px-4 py-2.5 text-sm transition-colors ${
      isActive
        ? 'bg-orange-50 text-orange-500 border-l-[3px] border-orange-500'
        : 'text-black hover:bg-gray-50 hover:text-black border-l-[3px] border-transparent'
    }`}
  >
    <span>{label}</span>
    {hasChevron && (
      <FiChevronRight
        className={`text-sm ${isActive ? 'text-orange-500' : 'text-black'}`}
      />
    )}
  </button>
);

// Sidebar Section Component
const SidebarSection = ({ title, children }) => (
  <div className="mb-1">
    <p className="px-4 py-2 text-[11px] font-semibold text-black uppercase tracking-wider">
      {title}
    </p>
    {children}
  </div>
);

const ShopFilters = ({
  categories,
  selectedCategory,
  onCategoryChange,
  priceRange,
  onPriceChange,
  onClearAll,
  hideHeader = false,
  priceOptions = [],
}) => (
  <div className="bg-white h-full">
    {/* Header - only show if not hidden */}
    {!hideHeader && (
      <div className="bg-slate-700 px-4 py-3">
        <div className="flex min-h-10 items-center justify-between gap-4">
          <h3 className="text-base font-bold text-white">Filters</h3>
          <button
            onClick={onClearAll}
            className="shrink-0 whitespace-nowrap rounded-lg px-3 py-2 text-sm font-medium text-orange-300 transition-colors hover:bg-white/10 hover:text-orange-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-300"
          >
            Clear All
          </button>
        </div>
      </div>
    )}

    {/* Navigation */}
    <nav className="py-3 overflow-y-auto">
      {/* Category */}
      <SidebarSection title="Category">
        <SidebarItem
          label="All Categories"
          isActive={selectedCategory === ''}
          onClick={() => onCategoryChange('')}
        />
        <LanguageMenu />
        {categories
          .filter((cat) => !isLanguageCategory(cat))
          .map((cat) => (
            <SidebarItem
              key={cat}
              label={cat}
              isActive={selectedCategory === cat}
              onClick={() => onCategoryChange(cat)}
            />
          ))}
      </SidebarSection>

      {/* Price */}
      <SidebarSection title="Price Range">
        {priceOptions.map((option) => (
          <SidebarItem
            key={option.value}
            label={option.label}
            isActive={priceRange === option.value}
            onClick={() => onPriceChange(option.value)}
          />
        ))}
      </SidebarSection>
    </nav>
  </div>
);

export default memo(ShopFilters);
